import { Card,CardContent,Grid,CardActionArea } from '@mui/material';
import { servicesCard } from '../services/cardData';
import { v4 as uuidv4 } from 'uuid';
import "../../../scss/common.scss";

interface props {
    serviceName:any
    setFindCards:any
}

const ServicesCard = (props:props) => {
    return (
        <>
            <Grid container spacing={4} className="service-select-user">
            {servicesCard?.map((card: any, index: number) =>
                <Grid item lg={3} md={4} sm={6} xs={12} key={uuidv4()}>
                        <Card sx={{ boxShadow:'none',borderRadius:'6px', 
                         "&:hover": {transition: "0.3s",outline: "1.5px solid #ffc816",boxShadow: "0px 1px 1px -1px"},
                    }} className="cursor-pointer card-hover-color" onClick={()=>{props.setFindCards(true);props.serviceName(card.title)}}>
                           <CardActionArea sx ={{pt:2, pb:1}} >
                                <CardContent sx={{ display: "block", textAlign: "center", pt: 4 }}>
                                    <img className = 'imgcolor'  src={card.image} alt="cards" />
                                    <p className='fs-18 fw-500'>{card.title}</p>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                </Grid>
            )}
            </Grid>
        </>
    )
}

export default ServicesCard;
